import React from 'react';
import PersistenceManager from "../../../functions/persistence";

const MainItemSelector = function(props) {
    function change(e) {
        props.handleChange(e);
    }
    return (
        <div>
            <select className="form-control" data-style="btn-primary" id={Math.random()} value={props.choice} onChange={change}>
                {props.items.map( (val, ind, arr) => {
                    let mainItemJ = JSON.stringify(val);
                    if (ind === 0) {
                        PersistenceManager.setChosenMainItem(mainItemJ);
                    }
                    return (<option key={ind} value={ind} data-val={mainItemJ}>{val.name}</option>);
                })}
            </select>
        </div>
    )
};
export default MainItemSelector;
